import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockText from "../../Block/BlockText";
import Block from "../../Block/Block";

function SsrDemoTool() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>SSR Demo Tool</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText></BlockText>
        </BlockContent>
      </Block>



      <Block gridTemplateColumns="1200px">
        <BlockContent width="100%"  textAlign="center">
          <BlockTitle>Comming Soon</BlockTitle>
        </BlockContent>
      </Block>

      <Footer/>
    </div>
  );
}

export default SsrDemoTool;